// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2P51h","selected":"Chip_selected__cxzV7"};